import {combineReducers} from 'redux';
import {setTopNavBarButtonAction, setTopNavBarTitleAction} from 'module/TopNavBar/action/TopNavBarAction';
import {createReducer} from '@reduxjs/toolkit';
import {TopNavBarButtonID} from 'module/TopNavBar/enum/TopNavBarButtonEnums';
import {TopNavBarButton} from 'module/TopNavBar/type/TopNavBarButton';

const title = createReducer<string>('', builder => builder
	.addCase(setTopNavBarTitleAction, (state, {payload}) => payload),
)

const buttons = createReducer<Partial<Record<TopNavBarButtonID, TopNavBarButton>>>({}, builder => builder
	.addCase(setTopNavBarButtonAction, (state, {payload}) => ({
		...state,
		[payload.name]: {
			...state[payload.name],
			...payload,
		},
	})),
)

export const TopNavBarReducerNS = {TopNavBar: combineReducers({title, buttons})}
export type TopNavBarStateType = { TopNavBar: ReturnType<typeof TopNavBarReducerNS.TopNavBar> }